<div>
    <mat-form-field *ngIf="!kompakt" style="min-width: 300px">
        <mat-label>Lieferant</mat-label>
        <mat-select [formControl]="supplierCtrl" [compareWith]="supplierMaterialComparator">
            <mat-option *ngFor="let sm of supplierMaterials" [value]="sm">{{ sm.lieferant }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="kompakt" class="supplier-kompakt" appearance="standard">
        <mat-select [formControl]="supplierCtrl" [compareWith]="supplierMaterialComparator">
            <mat-option *ngFor="let sm of supplierMaterials" [value]="sm">{{ sm.lieferant }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
